import { useState } from "react"

const useDateConvert = () => {
    // const [timestampToDateTime, setTimestampToDateTime] = useState()

    const getTimestampToDateTime = (timestamp) => {
        
        // Convert timestamp to milliseconds (JavaScript uses milliseconds)
        const date = new Date(timestamp * 1000);

        // Format the date in Indonesian locale
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour12: false, // Use 24-hour format
        };

        const indonesianDateTime = date.toLocaleString('id-ID', options);

        return indonesianDateTime
    }

    return {
        getTimestampToDateTime
    }
}
export default useDateConvert